import { sanitizeAnalyticsPath } from 'noddi-util';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { tracking } from './index';

type Props = {
  // Customer keeps Mixpanel path-as-event page tracking. Backoffice apps leave
  // this off — OpenPanel screen_view is enough.
  mixpanelPages?: boolean;
};

// OpenPanel Pages/Sessions (+ optional Mixpanel path events). Path + search are
// collapsed first (`/customers/12?page=2` → `/customers/:id`); the dispatcher
// drops a repeat of that template so filter/pagination churn does not POST.
export function TrackScreen({ mixpanelPages = false }: Props) {
  const location = useLocation();
  const pathname = sanitizeAnalyticsPath(location.pathname);
  const screenPath = sanitizeAnalyticsPath(`${location.pathname}${location.search}`);

  useEffect(() => {
    if (!mixpanelPages) {
      return;
    }
    tracking.track(pathname, undefined, { only: ['mixpanel'] });
  }, [mixpanelPages, pathname]);

  useEffect(() => {
    tracking.screenView(screenPath, { title: document.title });
  }, [screenPath]);

  return null;
}
